<template>
	<div id="app">
		<audio
			class="audio-cal"
			ref="audioRef"
			src="/style/assets/2.mp3"
			loop="loop"
			preload="auto"
			paused="false"
		></audio>
		<div
			ref="biaoqianRef"
			:class="['audio-icon', { 'active-audio-icon': isPlay }]"
			@click="audioClick"
		></div>
		<transition :name="transitionName">
			<router-view />
		</transition>
		<link rel="prefetch" href="/style/assets/2.mp3" />
		<link
			rel="prefetch"
			href="/style/assets/image/p5/foot-box.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/bg.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/bg2.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/cplr.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/01.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/02.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/03.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/04.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/05.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/06.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/07.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/08.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/09.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/10.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/11.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/xk/12.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p3/next-btn.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/001.gif"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/01.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/02.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/03.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/04.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/05.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/06.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/07.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/08.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/09.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/10.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/11.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/p4/bq/12.png"
		/>

		<link
			rel="prefetch"
			href="/style/assets/image/back-btn.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/body-img.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/btn_1.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/btn_bg_t.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/dialog_bg.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/djtq_icon.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/head-img.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/home-page_btn.png"
		/>

		<link
			rel="prefetch"
			href="/style/assets/image/left-btn.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/right-btn.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/shrea-btn.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/void1.png"
		/>
		<link
			rel="prefetch"
			href="/style/assets/image/yqhl.png"
		/>
	</div>
</template>
<script>
	import VConsole from 'vconsole'
	export default {
		components: {},
		data() {
			return {
				transitionName: 'slide-left',
				isPlay: false,
				isOpt: false,
				androidOpt: false,
				autoplay: false,
				VConsole,
			}
		},
		created() {
			// new VConsole()
			let u = navigator.userAgent
			let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
			if (!isiOS) {
				this.autoplay = 'true'
			}
		},
		mounted() {
			let _self = this
			document.addEventListener('DOMContentLoaded', function () {
				function audioAutoPlay() {
					//--创建页面监听，等待微信端页面加载完毕 触发音频播放
					document.addEventListener(
						'WeixinJSBridgeReady',
						function () {
							if (_self.$refs.audioRef && _self.$refs.audioRef.paused) {
								// 暂停中
								if (!_self.isOpt) {
									// alert(_self.$refs.audioRef.paused)
									_self.$refs.audioRef.play()
									_self.isPlay = true
									_self.isOpt = true
								}
							} else {
								// 播放中
								console.log('播放中')
							}
						},
						false
					)

					document.addEventListener(
						'YixinJSBridgeReady',
						function () {
							if (_self.$refs.audioRef && _self.$refs.audioRef.paused) {
								// 暂停中
								if (!_self.$refs.audioRef.played) {
									if (!_self.isOpt) {
										_self.$refs.audioRef.play()
										_self.isPlay = true
										_self.isOpt = true
									}
								}
							} else {
								// 播放中
								console.log('播放中')
							}
						},
						false
					)

					document.addEventListener(
						'touchstart',
						function () {
							// 暂停中
							if (_self.$refs.audioRef.paused) {
								if (!_self.isOpt) {
									_self.$refs.audioRef.play()
									_self.isPlay = true
									_self.isOpt = true
								}
							}
						},
						false
					)

					// 安卓机型
					let u = navigator.userAgent
					let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
					if (isAndroid) {
						if (!_self.isOpt) {
							_self.$nextTick(() => {
								console.log(_self.$refs.audioRef.paused)
								console.log(_self.$refs.audioRef.defaultMuted)

								setTimeout(() => {
									if (!_self.androidOpt) {
										_self.androidOpt = true
										console.log(_self.$refs.audioRef.paused)
										_self.$refs.audioRef.play()
										console.log(_self.$refs.audioRef.readyState)
									}
								}, 2000)
							})
						}
					}
				}
				audioAutoPlay()
			})
		},
		methods: {
			audioClick() {
				if (this.isPlay) {
					this.$refs.audioRef.pause()
				} else {
					this.$refs.audioRef.play()
				}
				this.isPlay = !this.isPlay
			},
		},
	}
</script>
<style lang="scss">
	#app {
		z-index: 100;
		// min-height: 8.893333rem;
		// overflow-y: auto;
	}
	@keyframes Xuanzhuan {
		0% {
			-webkit-transform: rotate(0deg);
		}
		50% {
			-webkit-transform: rotate(180deg);
		}
		100% {
			-webkit-transform: rotate(360deg);
		}
	}
	.slide-left-enter,
	.slide-right-leave-to {
		opacity: 0;
		width: 0;
		// transform: translateX(100%);
	}

	.slide-left-leave-to,
	.slide-right-enter {
		opacity: 1;
		width: 100%;
		// transform: translateX(-100%);
	}

	.slide-left-enter-active,
	.slide-left-leave-active,
	.slide-right-enter-active,
	.slide-right-leave-active {
		transition: opacity 0.6s;
		position: absolute;
		top: 0;
	}
	.audio-icon {
		height: 1.3rem;
		width: 1.3rem;
		border-radius: 1rem;
		background: url(./assets/image/void1.png) center center no-repeat;
		background-size: 80% 80%;
		position: fixed;
		top: 20px;
		right: 20px;
		z-index: 999;
		opacity: 0.4;
	}
	.active-audio-icon {
		-webkit-animation: Xuanzhuan 4s linear infinite;
		-moz-animation: Xuanzhuan 4s linear infinite;
		-ms-animation: Xuanzhuan 4s linear infinite;
		animation: Xuanzhuan 4s linear infinite;
	}
	.audio-cal {
		opacity: 0;
	}
</style>
